export type OpenIssueMatch = {
    questionIndex?: number | null;
    promptTitle?: string | null;
    promptLabel?: string | null;
    promptDescription?: string | null;
};

export type PromptIssueIdentity = {
    title?: string | null;
    label?: string | null;
    description?: string | null;
};

function norm(value?: string | null): string {
    return (value || '').trim().toLowerCase();
}

/**
 * Reuse an open ticket only for the same form item.
 * Index-only matching collapsed unrelated Daily Service rows (e.g. hydraulic oil + air to tire).
 */
export function isSameOpenIssueForPrompt(
    issue: OpenIssueMatch,
    prompt: PromptIssueIdentity,
    questionIndex: number,
): boolean {
    const issueLabel = norm(issue.promptLabel);
    const promptLabel = norm(prompt.label);
    if (!issueLabel || !promptLabel || issueLabel !== promptLabel) {
        return false;
    }
    if (issue.questionIndex != null && issue.questionIndex === questionIndex) {
        return true;
    }
    return (
        (issue.promptTitle || '') === (prompt.title || '') &&
        (issue.promptDescription || '') === (prompt.description || '')
    );
}

export function findMatchingOpenIssue<T extends OpenIssueMatch>(
    existingOpen: T[],
    prompt: PromptIssueIdentity,
    questionIndex: number,
): T | undefined {
    return existingOpen.find((issue) => isSameOpenIssueForPrompt(issue, prompt, questionIndex));
}
